import { h, Component } from 'preact';
import MiniEmploymentByIndustry from './MiniEmploymentByIndustry';
import data from '../../../data/data.json';
import { intcomma } from 'journalize';
import * as moment from 'moment';

class EmploymentByIndustryGrid extends Component {
  constructor() {
    super();
  }

  componentDidMount() {}

  render() {
    let industries = [];
    let employment_change_industry = data.employment_change_industry;
    // get unique industries
    employment_change_industry.forEach(d => {
      if (industries.indexOf(d.industry) == -1) {
        industries.push(d.industry);
      }
    });

    return (
      <div class="mini-industry-grid-container">
        <div class="mini-industry-grid">
          {industries.map((industry, i) => {
            let industryLosses = employment_change_industry
              .filter(
                d =>
                  d.industry == industry &&
                  d.monthly_change_thousands < 0 &&
                  moment(d.date, 'MMM-YY').isSameOrAfter(moment('2020-02-01'))
              )
              .reduce((a, b) => {
                return {
                  monthly_change_thousands:
                    a.monthly_change_thousands + b.monthly_change_thousands,
                };
              }).monthly_change_thousands;

            let industryGains = employment_change_industry
              .filter(
                d =>
                  d.industry == industry &&
                  d.monthly_change_thousands > 0 &&
                  moment(d.date, 'MMM-YY').isSameOrAfter(moment('2020-02-01'))
              )
              .reduce((a, b) => {
                return {
                  monthly_change_thousands:
                    a.monthly_change_thousands + b.monthly_change_thousands,
                };
              }).monthly_change_thousands;

            return (
              <div class="mini-industry-block">
                <div class="mini-industry-header-container">
                  <h4 class="mini-industry-header" style="white-space: nowrap;">
                    {industry}{' '}
                    {industry == 'Mining and logging'
                      ? '(includes oil and gas)'
                      : ''}
                  </h4>
                  <p class="mini-industry-caption">
                    Lost{' '}
                    <span class="font-weight-bold">
                      {intcomma(Math.abs(industryLosses))}
                    </span>{' '}
                    jobs and added{' '}
                    <span class="font-weight-bold">
                      {intcomma(Math.abs(industryGains))}
                    </span>{' '}
                    jobs between March 2020 and May 2021
                  </p>
                  {/* <p style="font-size: 12px;">
                    Down{' '}
                    <span class="font-weight-bold">
                      {intcomma(
                        Math.abs(
                          Math.round(
                            employment_change_industry.find(
                              d => d.industry == industry && d.date == 'Apr-20'
                            ).monthly_change_thousands
                          )
                        )
                      )}
                    </span>{' '}
                    jobs in April 2020
                  </p> */}
                  {/* <p style="font-size: 12px;">
                    Made up{' '}
                    {parseInt(
                      data.employment_industry_proportion.find(
                        d => d.industry == industry
                      )['percent_of_total_february_2019'] * 100
                    )}
                    % of Texas pre-pandemic jobs
                  </p> */}
                </div>
                <MiniEmploymentByIndustry industry={industry} index={i} />
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default EmploymentByIndustryGrid;
